import { useEffect, useMemo } from 'react';
import { useSlotListStyles } from './SlotList.styles';

// Resolved slot handed to the rendered row (label is a plain string).

// Authored slot in card JSON: its label may itself be a formattable binding.

/** @deprecated Use Loop + OptionButton with maxItems instead. */
import { jsx as _jsx } from "react/jsx-runtime";
const SlotList = ({
  name,
  selectedValue,
  slots,
  group,
  maxVisibleSlots,
  isDisabled,
  onChange
}) => {
  const {
    slotRowStyle,
    scrollContainerStyle
  } = useSlotListStyles();
  const visibleSlots = useMemo(() => {
    if (group) return slots.filter(s => s.group === group);
    if (group !== undefined) return [];
    return slots;
  }, [group, slots]);
  useEffect(() => {
    const isSelectionSelectable = visibleSlots.some(slot => slot.value === selectedValue);
    if (selectedValue && !isSelectionSelectable) {
      onChange(name, '');
    }
  }, [selectedValue, visibleSlots, name, onChange]);
  if (visibleSlots.length === 0) {
    return null;
  }
  const shouldScroll = maxVisibleSlots !== undefined && visibleSlots.length > maxVisibleSlots;
  return /*#__PURE__*/_jsx("div", {
    style: shouldScroll ? scrollContainerStyle(maxVisibleSlots) : undefined,
    children: visibleSlots.map(slot => {
      const isSelected = selectedValue === slot.value;
      return /*#__PURE__*/_jsx("div", {
        role: "option",
        "aria-selected": isSelected,
        "aria-disabled": isDisabled || undefined,
        tabIndex: isDisabled ? -1 : 0,
        style: slotRowStyle(isSelected, isDisabled !== null && isDisabled !== void 0 ? isDisabled : false),
        onClick: () => !isDisabled && onChange(name, slot.value),
        onKeyDown: e => {
          if (!isDisabled && (e.key === 'Enter' || e.key === ' ')) {
            e.preventDefault();
            onChange(name, slot.value);
          }
        },
        children: slot.label
      }, slot.value);
    })
  });
};
export default SlotList;